import debounceLodash from 'lodash/debounce';

export default class ComponentHelper {
  static debounce(onPress, time = 300) {
    return debounceLodash(onPress, time, { leading: true, trailing: false });
  }
}
